import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-lists-item-food',
  templateUrl: './products-lists-item-food.component.html',
  styleUrls: ['./products-lists-item-food.component.css']
})
export class ProductsListsItemFoodComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
